// extracted by mini-css-extract-plugin
export default {"pageWrap":"SWOTModelRoot_pageWrap__CGKC5"};